import CompanyPolicies from './CompanyPolicies';

export default CompanyPolicies;
